var __defProp = Object.defineProperty;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __publicField = (obj, key, value) => {
  __defNormalProp(obj, typeof key !== "symbol" ? key + "" : key, value);
  return value;
};
import { g as getGlobalSingleton, s as setGlobalSingleton } from "../global-33d5eebf.js";
import { InputEventType } from "../inputs/InputManager.js";
import { playSound } from "../utils/playSound.js";
import { flags } from "../console/flags.js";
import { debounce } from "lodash";
import "../loader/AssetLoader.js";
import "../loader/ImageLoader.js";
import "pixi.js";
import "../loader/SpriteLoader.js";
import "../loader/PixiSpriteLoader.js";
import "../loader/MapLoader.js";
import "../utils/colors.js";
import "../utils/sharedFetch.js";
import "../vendor/noise/index.js";
import "url";
import "@dimforge/rapier2d-compat";
import "../persist/persist.js";
import "../loader/PixiSpineLoader.js";
import "pixi-spine";
import "../loader/SoundLoader.js";
import "../_commonjsHelpers-7a77ea84.js";
import "../console/editor.js";
import "../components/ComponentRegistry.js";
import "../decorators/type.js";
import "ajv";
import "../utils/clone.js";
import "bitecs";
import "../utils/typehelpers.js";
import "../enums-86f58524.js";
import "../components/types.js";
import "../utils/byteArray.js";
import "../console/floatingwindow.js";
import "../Description-c36d0b9a.js";
import "../Attach-abbbd93e.js";
import "../utils/vector.js";
import "../utils/windowSessionStorage.js";
class UIService {
  constructor(uiCanvas) {
    __publicField(this, "elements", []);
    __publicField(this, "UICanvas");
    __publicField(this, "clickedElement");
    __publicField(this, "clickedElements");
    __publicField(this, "mouseOffset");
    __publicField(this, "interactionDiv");
    __publicField(this, "uiDiv");
    __publicField(this, "mappedIds", {});
    __publicField(this, "uiElements", {});
    __publicField(this, "keyPressListeners", []);
    __publicField(this, "lastMouseMove");
    __publicField(this, "debugCanvas");
    __publicField(this, "unsub");
    __publicField(this, "playerInputs", [[InputEventType.ANY, 0]]);
    __publicField(this, "ui", new Proxy(this.uiElements, {
      get: (target, prop) => {
        return target[prop];
      },
      set: (target, prop, value) => {
        if (target[prop]) {
          UIService.getInstance().removeFromUI(target[prop]);
        }
        target[prop] = value;
        UIService.getInstance().addToUI(value);
        return true;
      },
      deleteProperty: (target, prop) => {
        if (!target[prop]) {
          return true;
        }
        UIService.getInstance().removeFromUI(target[prop]);
        delete target[prop];
        return true;
      }
    }));
    __publicField(this, "_keyCaptureListener", (inputManager, key, pressed, eventType, inputIndex, e) => {
      var _a;
      const playerEventIndex = this.getPlayerEventIndex(eventType, inputIndex);
      if (!pressed || [InputEventType.TOUCH, InputEventType.MOUSE].includes(eventType)) {
        return;
      }
      let left = key === "left" || key === "a";
      let right = key === "right" || key === "d";
      let up = key === "up" || key === "w";
      let down = key === "down" || key === "s";
      if (eventType === InputEventType.GAMEPAD) {
        left = key === "left" || inputManager.keyPressed("a", eventType, inputIndex) && !inputManager.keyPressed("w", eventType, inputIndex) && !inputManager.keyPressed("s", eventType, inputIndex);
        right = key === "right" || inputManager.keyPressed("d", eventType, inputIndex) && !inputManager.keyPressed("w", eventType, inputIndex) && !inputManager.keyPressed("s", eventType, inputIndex);
        up = key === "up" || inputManager.keyPressed("w", eventType, inputIndex) && !inputManager.keyPressed("a", eventType, inputIndex) && !inputManager.keyPressed("d", eventType, inputIndex);
        down = key === "down" || inputManager.keyPressed("s", eventType, inputIndex) && !inputManager.keyPressed("a", eventType, inputIndex) && !inputManager.keyPressed("d", eventType, inputIndex);
      }
      if (left || right || up || down) {
        let direction = { x: 0, y: 0 };
        if (up) {
          direction.y -= 1;
        }
        if (down) {
          direction.y += 1;
        }
        if (left) {
          direction.x -= 1;
        }
        if (right) {
          direction.x += 1;
        }
        if (flags.DEBUG) {
          if (!this.debugCanvas) {
            this.createDebugCanvas();
          }
          this.debugCtx.clearRect(0, 0, this.debugCanvas.width, this.debugCanvas.height);
        } else if (this.debugCanvas) {
          this.debugCanvas.remove();
          this.debugCanvas = void 0;
        }
        if ((_a = this._focusedElementByPlayerIndex[playerEventIndex]) == null ? void 0 : _a._element) {
          this._focusedElementPositionByPlayerIndex[playerEventIndex] = this.getElementCenter(
            this._focusedElementByPlayerIndex[playerEventIndex]._element
          );
        }
        const focusedElement = this.findClosestFocusableElement(
          this._focusedElementPositionByPlayerIndex[playerEventIndex],
          direction,
          playerEventIndex
        );
        if (focusedElement) {
          this.setFocusedElementByPlayerIndex(playerEventIndex, focusedElement);
        }
        e == null ? void 0 : e.preventDefault();
        e == null ? void 0 : e.stopPropagation();
      }
      if (eventType === InputEventType.GAMEPAD && key === "q") {
        key = "escape";
      }
      switch (key.toLocaleLowerCase()) {
        case "space":
          if (this._focusedElementByPlayerIndex[playerEventIndex]) {
            this._focusedElementByPlayerIndex[playerEventIndex].onClick(playerEventIndex);
            e == null ? void 0 : e.preventDefault();
            e == null ? void 0 : e.stopImmediatePropagation();
          }
          break;
        case "escape":
          if (this._focusedElementByPlayerIndex[playerEventIndex]) {
            this._focusedElementByPlayerIndex[playerEventIndex].onEscape(playerEventIndex);
          }
          break;
      }
    });
    __publicField(this, "debugCtx");
    __publicField(this, "_focusedElementByPlayerIndex", []);
    __publicField(this, "_focusedElementPositionByPlayerIndex", {});
    __publicField(this, "getElementCenter", (element) => {
      if (!element || !element.parentElement) {
        return void 0;
      }
      const getScrollContainer = (element2) => {
        if (!element2) {
          return;
        }
        let possibleScrollContainer = element2;
        while (possibleScrollContainer.scrollHeight > possibleScrollContainer.clientHeight) {
          possibleScrollContainer = possibleScrollContainer.parentElement;
          if (!possibleScrollContainer) {
            return;
          }
          if (possibleScrollContainer.scrollHeight > possibleScrollContainer.clientHeight) {
            return possibleScrollContainer;
          }
        }
      };
      const focusableScrollContainer = getScrollContainer(element);
      let bounds = element.getBoundingClientRect();
      const center = {
        x: bounds.left + bounds.width / 2,
        y: bounds.top + bounds.height / 2
      };
      if (focusableScrollContainer) {
        const focusableScrollContainerBounds = focusableScrollContainer.getBoundingClientRect();
        const distanceFromFocusableTop = bounds.top - focusableScrollContainerBounds.top - focusableScrollContainer.scrollTop / focusableScrollContainer.scrollHeight * focusableScrollContainer.clientHeight;
        const distanceRatio = distanceFromFocusableTop / focusableScrollContainer.scrollHeight;
        center.y = center.y - distanceFromFocusableTop + focusableScrollContainer.clientHeight * distanceRatio;
      }
      if (flags.DEBUG) {
        if (!this.debugCanvas) {
          this.createDebugCanvas();
        }
        const ctx = this.debugCtx;
        ctx.fillStyle = "red";
        ctx.strokeStyle = "green";
        ctx.lineWidth = 2;
        ctx.beginPath();
        ctx.arc(center.x, center.y, 15, 0, 2 * Math.PI);
        ctx.fill();
        ctx.stroke();
      } else if (this.debugCanvas) {
        this.debugCanvas.remove();
        this.debugCanvas = void 0;
      }
      return center;
    });
    __publicField(this, "getFocusables", (playerIndex, autoFocus = false) => {
      let antiPlayerIndex = this.playerInputs.length > 1 ? this.playerInputs.reduce((acc, [], index) => {
        if (index === playerIndex) {
          return acc;
        }
        return acc.length ? ", .captureFocus" + index : ".captureFocus" + index;
      }, "") + " .focusable" : "";
      if (antiPlayerIndex.startsWith(", ")) {
        antiPlayerIndex = antiPlayerIndex.slice(2);
      }
      const unfocusables = antiPlayerIndex.length ? Array.from(this.uiDiv.querySelectorAll(antiPlayerIndex)) : [];
      const capturedFocuses = this.uiDiv.querySelector(
        `.captureFocus${playerIndex}:not(:has(.captureFocus${playerIndex}))`
      );
      let focusables;
      let div = this.uiDiv;
      if (capturedFocuses) {
        div = capturedFocuses;
      }
      focusables = div.querySelectorAll(autoFocus ? ".autoFocus" : ".focusable");
      focusables = Array.from(focusables).filter((x) => !unfocusables.includes(x));
      return focusables;
    });
    __publicField(this, "root");
    __publicField(this, "debouncedFocusCheck", debounce(
      () => {
        const playerIndices = this.playerInputs.map(([, index]) => index);
        for (let i = 0; i < playerIndices.length; i++) {
          const playerIndex = playerIndices[i];
          this.attemptAutoFocus(playerIndex);
        }
      },
      20,
      {
        leading: false,
        trailing: true
      }
    ));
    this.UICanvas = uiCanvas;
    this.interactionDiv = document.getElementById("interaction");
    this.uiDiv = document.getElementById("ui");
    this.registerEvents();
    this.root = {
      isVisible: () => true,
      update: () => {
        this.elements.forEach((element) => {
          if (!element.destroyed) {
            element._update();
          }
        });
      },
      addChild: (child) => {
        if (!this.elements.includes(child)) {
          this.elements.push(child);
        }
        child._update();
      },
      removeChild: (child) => {
        this.elements = this.elements.filter((x) => x !== child);
      },
      _element: this.uiDiv,
      _zIndex: 0,
      config: {
        children: []
      }
    };
  }
  getPlayerEventIndex(eventType, inputIndex, element) {
    if (this.playerInputs[0][0] === InputEventType.ANY) {
      return 0;
    }
    if (element && eventType === InputEventType.TOUCH) {
      const touchUsers = this.playerInputs.filter(([type]) => type === InputEventType.TOUCH);
      for (let i = 0; i < touchUsers.length; i++) {
        const focusables = this.getFocusables(i);
        if (focusables.includes(element._element)) {
          return i;
        }
      }
    }
    for (let i = 0; i < this.playerInputs.length; i++) {
      if (eventType === InputEventType.MOUSE && this.playerInputs[i][0] === InputEventType.KEYBOARD) {
        return i;
      }
      if (this.playerInputs[i][0] === eventType && this.playerInputs[i][1] === inputIndex) {
        return i;
      }
    }
    return -1;
  }
  enableKeyCapture(inputManager) {
    this.unsub = inputManager.addKeyListener((...args) => this._keyCaptureListener(inputManager, ...args));
  }
  disableKeyCapture() {
    if (this.unsub) {
      this.unsub();
      this.unsub = void 0;
    }
  }
  static configureUi(uiCanvas) {
    if (!getGlobalSingleton("UIService")) {
      setGlobalSingleton("UIService", new UIService(uiCanvas));
    }
  }
  static getInstance() {
    const instance = getGlobalSingleton("UIService");
    if (!instance) {
      UIService.configureUi();
    }
    return instance ?? getGlobalSingleton("UIService");
  }
  registerEvents() {
    window.addEventListener("resize", () => {
      this.elements.forEach((element) => {
        if (!element.destroyed) {
          element._update();
        }
      });
      setTimeout(() => {
        this.elements.forEach((element) => {
          if (!element.destroyed) {
            element._update();
          }
        });
      }, 100);
    });
    window.addEventListener("mousemove", () => {
      this.lastMouseMove = +/* @__PURE__ */ new Date();
    });
  }
  addKeyPressListener(listener) {
    this.keyPressListeners.push(listener);
    return () => {
      this.keyPressListeners = this.keyPressListeners.filter((l) => l !== listener);
    };
  }
  attemptMouseFocus(element) {
    const playerEventIndex = this.getPlayerEventIndex(InputEventType.MOUSE, 0);
    if (playerEventIndex === -1) {
      return;
    }
    const focusables = this.getFocusables(playerEventIndex);
    if (!focusables.includes(element._element)) {
      return;
    }
    const focuedElement = this._focusedElementByPlayerIndex[playerEventIndex];
    if (focuedElement !== element) {
      this.setFocusedElementByPlayerIndex(playerEventIndex, element);
    }
  }
  attemptAutoFocus(playerIndex) {
    if (!this._focusedElementByPlayerIndex[playerIndex]) {
      const availableAutoFocus = this.getFocusables(playerIndex, true);
      if (!availableAutoFocus.length) {
        return;
      }
      let closest = availableAutoFocus[0];
      if (this._focusedElementPositionByPlayerIndex[playerIndex]) {
        let closestDistance = Infinity;
        availableAutoFocus.forEach((element) => {
          var _a, _b;
          const center = this.getElementCenter(element);
          center.x += 1;
          const distance = (center.x - (((_a = this._focusedElementPositionByPlayerIndex[playerIndex]) == null ? void 0 : _a.x) ?? window.innerWidth / 2)) ** 2 + (center.y - (((_b = this._focusedElementPositionByPlayerIndex[playerIndex]) == null ? void 0 : _b.y) ?? window.innerHeight / 2)) ** 2;
          if (distance < closestDistance) {
            closest = element;
            closestDistance = distance;
          }
        });
      }
      this._focusedElementByPlayerIndex[playerIndex] = this.mappedIds[closest.id];
      this.mappedIds[closest.id]._update();
    }
  }
  elementFocusIndices(element) {
    const indices = [];
    for (let i = 0; i < this._focusedElementByPlayerIndex.length; i++) {
      if (this._focusedElementByPlayerIndex[i] === element) {
        indices.push(i);
      }
    }
    return indices;
  }
  traverseParentFocusByPlayerIndex(playerIndex) {
    var _a;
    let nestedParent = (_a = this._focusedElementByPlayerIndex[playerIndex]) == null ? void 0 : _a._parent;
    while (nestedParent) {
      if (nestedParent.config.focusable) {
        this.setFocusedElementByPlayerIndex(playerIndex, nestedParent);
        return;
      }
      nestedParent = nestedParent._parent;
    }
    this.setFocusedElementByPlayerIndex(playerIndex, void 0);
  }
  setFocusedElementByPlayerIndex(playerIndex, element) {
    const previous = this._focusedElementByPlayerIndex[playerIndex];
    this._focusedElementByPlayerIndex[playerIndex] = element;
    if (element) {
      this._focusedElementPositionByPlayerIndex[playerIndex] = this.getElementCenter(element._element);
      element._update();
    }
    if (!element) {
      setTimeout(() => {
        this.debouncedFocusCheck();
      }, 0);
    }
    if (previous && !(previous == null ? void 0 : previous.destroyed)) {
      previous._update();
    }
  }
  clearFocusedElementByPlayerIndex(playerIndex) {
    const previous = this._focusedElementByPlayerIndex[playerIndex];
    this._focusedElementByPlayerIndex[playerIndex] = void 0;
    this._focusedElementPositionByPlayerIndex[playerIndex] = void 0;
    setTimeout(() => {
      if (previous && !(previous == null ? void 0 : previous.destroyed)) {
        previous._update();
      }
      this.debouncedFocusCheck();
    }, 0);
  }
  createDebugCanvas() {
    if (!this.debugCanvas) {
      this.debugCanvas = document.createElement("canvas");
      this.debugCanvas.width = window.innerWidth;
      this.debugCanvas.height = window.innerHeight;
      this.debugCanvas.style.position = "absolute";
      this.debugCanvas.style.top = "0";
      this.debugCanvas.style.left = "0";
      this.debugCanvas.style.pointerEvents = "none";
      this.debugCanvas.style.zIndex = "100000";
      document.body.appendChild(this.debugCanvas);
    }
    this.debugCtx = this.debugCanvas.getContext("2d");
    this.debugCtx.clearRect(0, 0, this.debugCanvas.width, this.debugCanvas.height);
  }
  findClosestFocusableElement(elementCenter, direction, playerIndex) {
    if (!elementCenter) {
      elementCenter = {
        x: window.innerWidth / 2,
        y: window.innerHeight / 2
      };
    }
    let closestElement;
    let closestDistance = Infinity;
    const candidates = [];
    const focusables = this.getFocusables(playerIndex);
    focusables.forEach((focusable) => {
      const center = this.getElementCenter(focusable);
      if (!center || center.x === elementCenter.x && center.y === elementCenter.y) {
        return;
      }
      if (direction.x === 1 && center.x <= elementCenter.x) {
        return;
      }
      if (direction.x === -1 && center.x >= elementCenter.x) {
        return;
      }
      if (direction.y === 1 && center.y <= elementCenter.y) {
        return;
      }
      if (direction.y === -1 && center.y >= elementCenter.y) {
        return;
      }
      candidates.push([focusable, center]);
    });
    if (candidates.length === 0) {
      return;
    }
    for (let i = 0; i < candidates.length; i++) {
      const [focusable, center] = candidates[i];
      const angle = Math.atan2(center.y - elementCenter.y, center.x - elementCenter.x) * (180 / Math.PI);
      let distance = Math.sqrt((center.x - elementCenter.x) ** 2 + (center.y - elementCenter.y) ** 2);
      const directionAngle = Math.atan2(direction.y, direction.x) * (180 / Math.PI);
      const angleDifference = Math.abs(directionAngle - angle);
      if (Math.abs(angleDifference) > 30) {
        continue;
      }
      distance *= Math.abs(angleDifference) / 30 * 1 + 1;
      if (!closestDistance || distance < closestDistance) {
        closestDistance = distance;
        closestElement = this.mappedIds[focusable.id];
      }
    }
    if (!closestElement) {
      for (let i = 0; i < candidates.length; i++) {
        const [focusable, center] = candidates[i];
        const distance = Math.sqrt((center.x - elementCenter.x) ** 2 + (center.y - elementCenter.y) ** 2);
        if (distance && distance < closestDistance) {
          closestDistance = distance;
          closestElement = this.mappedIds[focusable.id];
        }
      }
    }
    return closestElement;
  }
  addToUI(element) {
    if (!this.root._element) {
      console.error("Root element is not set");
      return;
    }
    element.parent = this.root;
    this.debouncedFocusCheck();
  }
  removeFromUI(element) {
    if (!element) {
      return;
    }
    if (Array.isArray(element)) {
      element.forEach((e) => {
        if (e._parent && e._parent.config.children) {
          e._parent.config.children = e._parent.config.children.filter((x) => x !== e);
        }
        if (e.onDestroy) {
          e.onDestroy();
        }
        if (e) {
          this.elements.splice(this.elements.indexOf(e), 1);
          delete this.uiElements[e.id];
        }
      });
    } else {
      if (element._parent && element._parent.config.children) {
        element._parent.config.children = element._parent.config.children.filter((x) => x !== element);
      }
      if (element.onDestroy) {
        element.onDestroy();
      }
      const eleIndex = this.elements.indexOf(element);
      if (eleIndex === -1) {
        return;
      }
      this.elements.splice(this.elements.indexOf(element), 1);
      delete this.uiElements[element.id];
    }
  }
  getById(id) {
    const needle = this.elements.find((x) => x.id === id);
    if (!needle) {
      return void 0;
    }
    return needle;
  }
  removeFromUIByID(id) {
    const needle = this.elements.find((x) => x.id === id);
    if (needle !== void 0) {
      needle.onDestroy();
      this.elements.splice(this.elements.indexOf(needle), 1);
      delete this.uiElements[id];
    } else {
      console.warn(`could not find element with ID: ${id}`);
    }
  }
  clearUI() {
    console.log("Clearing UI");
    this.disableKeyCapture();
    if (this.debugCanvas) {
      this.debugCtx.clearRect(0, 0, this.debugCanvas.width, this.debugCanvas.height);
    }
    this.elements.forEach((x) => {
      if (x.onDestroy) {
        x.onDestroy(true);
      }
    });
    Object.entries(this.uiElements).forEach(([key, value]) => {
      delete this.uiElements[key];
    });
    this._focusedElementByPlayerIndex = [];
    this._focusedElementPositionByPlayerIndex = {};
    this.mappedIds = {};
    this.elements = [];
  }
  playSound(name, options) {
    playSound(name, options);
  }
}
export {
  UIService
};
//# sourceMappingURL=UIService.js.map
